import React, {FC} from 'react';
import {TooltipProps, withStyles} from '@material-ui/core';

import Tooltip from '../common/Tooltip';
import GameInfo from '../game-info/GameInfo';
import {getDirectionStyles} from '../../utils/ThemeUtils';

const StyledPopover = withStyles(theme => ({
    popper: {
        pointerEvents: 'none'
    },
    tooltip: {
        margin: 0,
        transform: `${getDirectionStyles(theme.direction)(
            'translate(-20px, calc(100% - 10px))',
            'translate(20px, calc(100% - 10px))'
        )} !important`
    }
}))(Tooltip);

export interface TooltipPopoverProps extends TooltipProps {
    title: string | number;
    secondaryText: string | number;
}

const TooltipPopover: FC<TooltipPopoverProps> = ({
    open,
    title,
    secondaryText,
    children
}: TooltipPopoverProps) => {
    return (
        <StyledPopover
            open={open}
            placement="top-start"
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={<GameInfo title={String(title)} code={String(secondaryText)} />}>
            {children}
        </StyledPopover>
    );
};

export default TooltipPopover;
